import { useEffect } from "react";

import { LabelPrint, OrderFields } from "../../constants";
import useOrderFormik from "../useOrderFormik";
import { useRouter } from "@lib/router";
import shouldAutoPrintLabel from "../../utils/shouldAutoPrintLabel";

// If delivery is not domestic, label print value is always that courier will bring label
const useDefaultLabelPrint = (): void => {
  const {
    values: { [OrderFields.LABEL_PRINT]: labelPrint, [OrderFields.IS_FROM_ORIGIN]: isFromOrigin, [OrderFields.DELIVERY_METHOD]: deliveryMethod },
    setFieldValue,
  } = useOrderFormik();

  const { defaultLocale } = useRouter();

  useEffect(() => {
    if (!isFromOrigin) {
      setFieldValue(OrderFields.LABEL_PRINT, LabelPrint.COURIER);
    }

    if (shouldAutoPrintLabel(defaultLocale, deliveryMethod, labelPrint)) {
      setFieldValue(OrderFields.LABEL_PRINT, LabelPrint.PRINT);
    }
  }, [isFromOrigin, labelPrint, setFieldValue, deliveryMethod]);
};
export default useDefaultLabelPrint;
